export const Event = {
    LIST_UPDATED: 'LIST_UPDATED',
    NEW_LIST_ITEM_ADDED: 'NEW_LIST_ITEM_ADDED',
    NEW_LIST_ITEM_UPDATED: 'NEW_LIST_ITEM_UPDATED',
    LIST_ITEM_DELETED: 'LIST_ITEM_DELETED',
    LIST_DELETED: 'LIST_DELETED',
    LIST_CREATED: 'LIST_CREATED',
};